import gql from "graphql-tag";
import { Fragment, Template } from "../types";
import {
  ContractTemplateMinimalFragment,
  CONTRACT_TEMPLATE_MINIMAL_FRAGMENT,
} from "./ContractTemplate";
import {
  TemplateSectionFragment,
  TEMPLATE_SECTION_FRAGMENT,
} from "./TemplateSection";

export const TEMPLATE_FRAGMENT = gql`
  fragment TemplateFragment on Template {
    id
    slug
    createdAt
    updatedAt
    default
    color
    title
    taskTrackingEnabled
    color
    contractTemplateIds
    canInsert
    contractTemplates {
      ...ContractTemplateMinimalFragment
    }
    templateSections {
      ...TemplateSectionFragment
    }
  }

  ${CONTRACT_TEMPLATE_MINIMAL_FRAGMENT}
  ${TEMPLATE_SECTION_FRAGMENT}
`;

export type TemplateFragment = Fragment<
  Template,
  Omit<Template, "contractTemplates"> & {
    contractTemplates: ContractTemplateMinimalFragment[];
  } & { templateSections: TemplateSectionFragment[] }
>;
